import _toConsumableArray from "/var/lib/jenkins/workspace/aws-PROD-deploy-react-form/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _taggedTemplateLiteral from "/var/lib/jenkins/workspace/aws-PROD-deploy-react-form/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n\t", "\n\t", "\n\t", "\n\talign-items: ", ";\n\t", "\n\t", ";\n\t", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n\toverflow: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n\tflex-shrink: 0;\n\tmax-width: 100%;\n\n\t", ";\n\t", ";\n\t", ";\n\n\t:empty {\n\t\t// if a child renders nothing, the wrapper should also not be rendered\n\t\tdisplay: none;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import * as React from 'react';
import { styled } from '../theme-provider';
import { createCSSVariablesForSizes, createHorizontalAlignmentStyles, createSpacingAroundElementsStyles, createSpacingBetweenElementsStyles, createWrapStyles } from './helpers';
import { createElectricTransition } from '../helpers';
var StyledChildWrapper = styled.div.withConfig({
  displayName: "StyledChildWrapper",
  componentId: "sc-1d21nde"
})(_templateObject(), function (props) {
  return props.stretchContent && 'flex-grow: 1;';
}, function (props) {
  return props.shrinkContent && 'flex-shrink: 1;';
}, function (props) {
  return createSpacingBetweenElementsStyles(props.wrap, props.theme, props.gutter);
});
StyledChildWrapper.displayName = 'StyledChildWrapper';
var StyledOverflowWrapper = styled.div.withConfig({
  displayName: "StyledOverflowWrapper",
  componentId: "sc-mfnmbg"
})(_templateObject2(), function (props) {
  return props.wrap ? '' : 'hidden';
});
StyledOverflowWrapper.displayName = 'StyledOverflowWrapper'; // `flex-grow: 1;` for stretchContent is needed for cases where the content does not bring its own width and instead relies on the width
// of the container. Combined with the container being inside a different flex element.
// Example: <Layout><Container stretchContent><AspectRatioContainer /></Container></Layout>
// Also see "components-cms/mood-gallery"
//
// To use transition for some properties:
// animateChange={['padding', 'opacity']}

var StyledContainer = styled.div.withConfig({
  displayName: "StyledContainer",
  componentId: "sc-18harj2"
})(_templateObject3(), function (props) {
  return props.gutter && createCSSVariablesForSizes(props.gutter, props.theme);
}, function (props) {
  return props.padding && createCSSVariablesForSizes(props.padding, props.theme);
}, function (props) {
  return createWrapStyles(props.wrap, props.theme, props.gutter);
}, function (props) {
  return props.verticalAlign;
}, function (props) {
  return props.horizontalAlign && createHorizontalAlignmentStyles(props.horizontalAlign);
}, function (props) {
  return props.padding && createSpacingAroundElementsStyles(props.padding, props.theme);
}, function (props) {
  return props.animateChange && createElectricTransition.apply(void 0, _toConsumableArray(props.animateChange));
});
StyledContainer.displayName = 'StyledContainer';
export var Container = React.forwardRef(function (props, ref) {
  var children = props.children,
      gutter = props.gutter,
      padding = props.padding,
      wrap = props.wrap,
      stretchContent = props.stretchContent,
      shrinkContent = props.shrinkContent,
      verticalAlign = props.verticalAlign,
      horizontalAlign = props.horizontalAlign,
      animateChange = props.animateChange;
  var childElements = React.Children.toArray(children).filter(React.isValidElement);

  if (!childElements.length) {
    return null;
  }

  return React.createElement(StyledOverflowWrapper, {
    ref: ref,
    wrap: wrap
  }, React.createElement(StyledContainer, {
    gutter: gutter,
    padding: padding,
    wrap: wrap,
    shrinkContent: shrinkContent,
    verticalAlign: verticalAlign,
    horizontalAlign: horizontalAlign,
    animateChange: animateChange
  }, childElements.map(function (child) {
    var key = child.key === null ? undefined : child.key;
    return React.createElement(StyledChildWrapper, {
      key: key,
      gutter: gutter,
      wrap: wrap,
      stretchContent: stretchContent,
      shrinkContent: shrinkContent
    }, child);
  })));
});
Container.displayName = 'Container';